import React from 'react'
import styles from '../modalComponent.module.scss'
import Flexxi from '../../../../../icons/flexiiLogo.svg'
import { useDispatch, useSelector } from 'react-redux'
import emailValidator from '../../../../../utils/validators/emailValidator'
import { setSignInWithEmailFormValidation } from '../../../../../redux/actions/validation'
import Input from '../../../../UiKitComponents/Input'
import { setPdfEmail } from '../../../../../redux/actions/pdfInputEmail'
import { setUserEmail } from '../../../../../redux/actions/authActions'
import { setAdditionalEmail } from '../../../../../redux/actions/quizQuestions'
import { setConfirmationModalForm } from '../../../../../redux/actions/confirmationModal'
const EditEmailComponent = ({ item }) => {
  const {
    validation: {
      signInWithEmailFormValidation: { emailErr, passwordErr },
    },
  } = useSelector((state) => state)
  const { additionalEmail } = useSelector((state) => state.quizQuestions)
  const dispatch = useDispatch()

  const validationEmail = (field, value) => {
    let inValid = false
    if (!value) {
      inValid = true
      dispatch(
        setSignInWithEmailFormValidation(field + 'Err', 'E-Mail ist erforderlich'),
      )
    } else if (!emailValidator(value)) {
      inValid = true
      dispatch(
        setSignInWithEmailFormValidation(field + 'Err', 'E-Mail ist erforderlich'),
      )
      // setErrorMessage('Falsche E-Mail oder Passwort')
    }
    return inValid
  }
  const handleChangeEmail = (field, value) => {
    dispatch(setSignInWithEmailFormValidation(field + 'Err', null))
    emailValidator(value) && dispatch(setPdfEmail(value))
    emailValidator(value)
      ? dispatch(
          setConfirmationModalForm({
            isInValid: false,
          }),
        )
      : dispatch(
          setConfirmationModalForm({
            isInValid: true,
          }),
        )
  }
  const handleBlurEmailField = (field, value) => {
    validationEmail(field, value)
  }
  return (
    <div className={styles.addEmailComponent}>
      <div>
        <img src={Flexxi} alt={Flexxi} />
        <p>Hier können Sie Ihre E-Mail-Adresse bearbeiten.</p>
      </div>
      <div>
        <input
          // ref={inputRef}
          defaultValue={item}
          type={'text'}
          placeholder={'Geben Sie eine Antwort ein.'}
          validationMessage={emailErr}
          onChange={(e) => handleChangeEmail('email', e.currentTarget.value)}
          onBlur={(e) => handleBlurEmailField('email', e.currentTarget.value)}
        />
      </div>
    </div>
  )
}
export default EditEmailComponent
